export default [
  { label: "University", value: "university" },
  { label: "Law Firm", value: "lawFirm" },
];

export const types = {
  university: "University",
  lawFirm: "Law Firm",
};
